import React from 'react';
import { SVGProps } from './type';

const IconChain = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M8.83333 10.8333C9.19121 11.3118 9.6478 11.7077 10.1721 11.9941C10.6965 12.2806 11.2763 12.4509 11.8722 12.4936C12.4682 12.5363 13.0663 12.4503 13.6261 12.2415C14.1859 12.0327 14.6943 11.7059 15.1167 11.2833L17.6167 8.78333C18.3757 7.99749 18.7956 6.94498 18.7861 5.8525C18.7766 4.76001 18.3384 3.71496 17.5659 2.94242C16.7934 2.16989 15.7483 1.73169 14.6558 1.72219C13.5634 1.7127 12.5108 2.13268 11.725 2.89167L10.2917 4.31667"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1667 9.16667C11.8088 8.68823 11.3522 8.29235 10.8279 8.00588C10.3035 7.71942 9.72374 7.54907 9.12779 7.50639C8.53184 7.46371 7.93368 7.54969 7.37388 7.75851C6.81408 7.96734 6.30574 8.29411 5.88333 8.71667L3.38333 11.2167C2.62434 12.0025 2.20437 13.055 2.21386 14.1475C2.22335 15.24 2.66156 16.285 3.43409 17.0576C4.20662 17.8301 5.25168 18.2683 6.34416 18.2778C7.43665 18.2873 8.48916 17.8673 9.275 17.1083L10.7 15.6833"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

export default IconChain;
